let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lpb1Z")).then(() => parcelRequire('eUCn3'));